(() => {
  if (window.NoCrowdIntrovertBingoLoaded) return;
  window.NoCrowdIntrovertBingoLoaded = true;

  const BINGO_LINES = [
    [0, 1, 2, 3, 4],
    [5, 6, 7, 8, 9],
    [10, 11, 12, 13, 14],
    [15, 16, 17, 18, 19],
    [20, 21, 22, 23, 24],

    [0, 5, 10, 15, 20],
    [1, 6, 11, 16, 21],
    [2, 7, 12, 17, 22],
    [3, 8, 13, 18, 23],
    [4, 9, 14, 19, 24],

    [0, 6, 12, 18, 24],
    [4, 8, 12, 16, 20]
  ];

  const LEVELS = [
    {
      min: 0,
      max: 4,
      title: "SUSPICIOUSLY SOCIAL",
      description:
        "You willingly answer phone calls? Interesting. We'll be keeping an eye on you."
    },
    {
      min: 5,
      max: 8,
      title: "PART-TIME INTROVERT",
      description:
        "You like your alone time, but you're still willing to occasionally interact with civilization. In moderation."
    },
    {
      min: 9,
      max: 12,
      title: "CERTIFIED INTROVERT",
      description:
        "You've mastered the strategic exit, the ignored phone call, and the art of hoping plans get cancelled."
    },
    {
      min: 13,
      max: 16,
      title: "PROFESSIONAL PEOPLE AVOIDER",
      description:
        "Your social battery doesn't die. It arrives pre-depleted. You've planned escape routes from conversations that haven't even happened yet."
    },
    {
      min: 17,
      max: 20,
      title: "NO CROWD MATERIAL",
      description:
        "Crowded room? Nope. Unexpected phone call? Absolutely not. Somebody says, 'Let's introduce ourselves'? You're already looking for the exit."
    },
    {
      min: 21,
      max: 24,
      title: "LEGENDARY INTROVERT",
      description:
        "You didn't find No Crowd Clothing. No Crowd Clothing found you. Your favorite crowd size is approximately zero."
    }
  ];


  function initializeBingo(root) {
    if (!root || root.dataset.bingoInitialized === "true") return;

    root.dataset.bingoInitialized = "true";

    const cells = Array.from(
      root.querySelectorAll("[data-bingo-cell]")
    );

    const scoreElements = root.querySelectorAll(
      "[data-bingo-score], [data-bingo-score-large]"
    );

    const levelElement = root.querySelector("[data-bingo-level]");
    const descriptionElement = root.querySelector(
      "[data-bingo-description]"
    );

    const bingoCountElement = root.querySelector(
      "[data-bingo-count]"
    );

    const bingoWordElement = root.querySelector(
      "[data-bingo-word]"
    );

    const bingoBonusElement = root.querySelector(
      "[data-bingo-bonus]"
    );

    const resetButton = root.querySelector(
      "[data-bingo-reset]"
    );

    const shareButton = root.querySelector(
      "[data-bingo-share]"
    );


    function getSelectedIndexes() {
      const selected = new Set([12]);

      cells.forEach((cell) => {
        if (cell.getAttribute("aria-pressed") === "true") {
          selected.add(Number(cell.dataset.index));
        }
      });

      return selected;
    }


    function calculateBingos(selected) {
      return BINGO_LINES.filter((line) =>
        line.every((index) => selected.has(index))
      ).length;
    }


    function getLevel(score) {
      return LEVELS.find(
        (level) => score >= level.min && score <= level.max
      );
    }


    function getBonusText(bingos, score) {
      if (score === 24) {
        return "Achievement unlocked: NO CROWD LEGEND.";
      }

      if (bingos >= 4) {
        return "This is getting impressive.";
      }

      if (bingos >= 2) {
        return "Advanced People Avoidance.";
      }

      if (bingos === 1) {
        return "Certified Crowd Dodger.";
      }

      return "Keep checking squares.";
    }


    function updateGame() {
      const score = cells.filter(
        (cell) => cell.getAttribute("aria-pressed") === "true"
      ).length;

      const selected = getSelectedIndexes();

      const bingos = calculateBingos(selected);

      const level = getLevel(score);

      scoreElements.forEach((element) => {
        element.textContent = score;
      });

      if (levelElement && level) {
        levelElement.textContent = level.title;
      }

      if (descriptionElement && level) {
        descriptionElement.textContent = level.description;
      }

      if (bingoCountElement) {
        bingoCountElement.textContent = bingos;
      }

      if (bingoWordElement) {
        bingoWordElement.textContent =
          bingos === 1 ? "BINGO" : "BINGOS";
      }

      if (bingoBonusElement) {
        bingoBonusElement.textContent =
          getBonusText(bingos, score);
      }

      root.dataset.currentScore = score;
      root.dataset.currentLevel = level
        ? level.title
        : "";
    }


    cells.forEach((cell) => {
      cell.addEventListener("click", () => {
        const active =
          cell.getAttribute("aria-pressed") === "true";

        cell.setAttribute(
          "aria-pressed",
          active ? "false" : "true"
        );

        cell.classList.toggle(
          "is-checked",
          !active
        );

        updateGame();
      });
    });


    if (resetButton) {
      resetButton.addEventListener("click", () => {
        cells.forEach((cell) => {
          cell.setAttribute("aria-pressed", "false");
          cell.classList.remove("is-checked");
        });

        updateGame();
      });
    }


    if (shareButton) {
      shareButton.addEventListener("click", async () => {
        const score = root.dataset.currentScore || "0";
        const level =
          root.dataset.currentLevel || "INTROVERT";

        const shareText =
          `I scored ${score}/24 on Introvert Bingo — ${level}.`;

        const shareData = {
          title: "Introvert Bingo",
          text: shareText,
          url: window.location.href
        };

        try {
          if (navigator.share) {
            await navigator.share(shareData);
          } else if (navigator.clipboard) {
            await navigator.clipboard.writeText(
              `${shareText} ${window.location.href}`
            );

            const originalText =
              shareButton.textContent;

            shareButton.textContent =
              "SCORE COPIED!";

            window.setTimeout(() => {
              shareButton.textContent =
                originalText;
            }, 2000);
          }
        } catch (error) {
          console.debug("Share cancelled.");
        }
      });
    }


    updateGame();
  }


  function initializeAllBingos() {
    document
      .querySelectorAll("[data-introvert-bingo]")
      .forEach(initializeBingo);
  }


  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeAllBingos
    );
  } else {
    initializeAllBingos();
  }


  document.addEventListener(
    "shopify:section:load",
    (event) => {
      const root =
        event.target.querySelector(
          "[data-introvert-bingo]"
        ) ||
        event.target.closest(
          "[data-introvert-bingo]"
        );

      if (root) {
        initializeBingo(root);
      }
    }
  );
})();